// extracted by mini-css-extract-plugin
export var videoResponsive = "Video-module--videoResponsive--229fa";